/**
 * EU member states: allergen information is mandatory there, so the editor
 * opens «Alérgenos» expanded (plan §5.12).
 */
export const EU_COUNTRIES: ReadonlySet<string> = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]);

export function isEuCountry(country: string | null | undefined): boolean {
  return !!country && EU_COUNTRIES.has(country.toUpperCase());
}
